/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 * LanguageDropdown Messages
 *
 * This contains all the text for the LanguageDropdown component.
 * This uses Google Translate, blame Google.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  dropdownLabel: {
    id: 'Dropdown_Label',
    defaultMessage:'Change Your Language',
  },
  currentItemLabel: {
    id: 'Current_Link',
    defaultMessage: 'Current link',
  },
});
